/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Pdfs_Work_Best_WhenInputs */

const en_mobile_pdfs_work_best_when = /** @type {(inputs: Mobile_Pdfs_Work_Best_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFs work best when they're uploaded using the Share button.

Here's how to share a PDF:`)
};

const es_mobile_pdfs_work_best_when = /** @type {(inputs: Mobile_Pdfs_Work_Best_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los PDF funcionan mejor cuando se suben usando el botón Compartir.

Aquí te mostramos cómo compartir un PDF:`)
};

/**
* | output |
* | --- |
* | "PDFs work best when they're uploaded using the Share button. Here's how to share a PDF:" |
*
* @param {Mobile_Pdfs_Work_Best_WhenInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_pdfs_work_best_when = /** @type {((inputs?: Mobile_Pdfs_Work_Best_WhenInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Pdfs_Work_Best_WhenInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_pdfs_work_best_when(inputs)
	return en_mobile_pdfs_work_best_when(inputs)
});